<div class="container-fluid py-5">
  <!-- <div class="card-tools"> -->

  <div class="row justify-content-center">
    <div class="col-4 col-md-2" *ngFor="let card of resumenCards; index as i">
      <!-- [class]="i < 2 ? 'col-md-6' : 'col-md-4'" -->
      <div
        class="card card-stats"
        [ngClass]="{ 'card-stats__selected': i === 1 }"
        [routerLink]="card.route"
        [style.cursor]="card.route ? 'pointer' : 'default'"
      >
        <div class="card-body">
          <div class="row">
            <div class="col-12 col-md-7 col-lg-6">
              <div
                class="icon-big text-center text-dark rounded shadow"
                [ngClass]="card.bgClass"
              >
                <i [class]="card.icon"></i>
              </div>
            </div>
            <div class="col-7 d-flex flex-column justify-content-center">
              <p class="card-category mb-0">{{ card.label }}</p>
              <h4
                class="card-title mb-0"
                [ngClass]="{ 'text-dark': i === 1, 'text-white': i !== 1 }"
              >
                <!-- {{ card.value }} -->
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="stats">
            <small [class]="i == 1 ? 'desc__selected' : 'desc'">{{
              card.desc
            }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-tools">
    <div class="row text-center">
      <div class="col-12">
        <a
          [routerLink]="['/numbers/finance/stripe']"
          class="btn btn-dark btn-sm btn-redirect"
        >
          Stripe
        </a>
        <a
          [routerLink]="['/numbers/finance/square']"
          class="btn btn-dark btn-sm btn-redirect"
        >
          Square
        </a>
        <a
          [routerLink]="['/numbers/finance/paypal']"
          class="btn btn-dark btn-sm btn-redirect"
        >
          Paypal
        </a>
      </div>
    </div>
  </div>
</div>
